import React from 'react'
import ReactDOM from 'react-dom'
import { App } from './App'

if (typeof NodeList.prototype.forEach !== 'function') {
  NodeList.prototype.forEach = Array.prototype.forEach
}

ReactDOM.render(<App />, document.getElementById('products'))
